<template>
    <Button
        :type="isNotEmpty ? 'primary' : 'default'"
        :ghost="isNotEmpty"
        @click="onClick"
    >
        <span class="adv-text">筛选</span>
        <common-icon
            class="adv-icon"
            type="ios-funnel"
            :size="14"
            :color="isNotEmpty ? $theme.primaryColor : 'black'"
        />
        <smart-modal
            v-model="show"
            :width="600"
            :height="500"
            :maskClosable="false"
            :showHeader="false"
            :modalBeforeEnter="fetch"
            :modalBeforeBtnClick="btnHandlers"
            :buttons="buttons"
            @close-by-confirm="onConfirm"
        >
            <Form
                class="adv-form"
                ref="pInfo"
                :model="pInfo"
                :rules="rules"
                :label-width="200"
                label-position="top"
            >
                <FormItem label="房间状态" prop="houseStatus">
                    <check-tag-group
                        v-model="pInfo.houseStatus"
                        color="primary"
                        multiple
                    >
                        <check-tag
                            v-for="item in option.houseStatus"
                            class="adv-check-tag"
                            :name="item.id"
                            :key="item.id"
                        >
                            {{ item.text }}
                        </check-tag>
                    </check-tag-group>
                </FormItem>
                <FormItem label="出租类型" prop="rentType">
                    <check-tag-group
                        v-model="pInfo.rentType"
                        color="primary"
                        multiple
                    >
                        <check-tag
                            v-for="item in dict.rentTypeNew.toList()"
                            class="adv-check-tag"
                            :name="item.id"
                            :key="item.id"
                        >
                            {{ item.text }}
                        </check-tag>
                    </check-tag-group>
                </FormItem>
                <!-- <FormItem label="朝向" prop="orientation">
                    <check-tag-group
                        v-model="pInfo.orientation"
                        color="primary"
                        multiple
                    >
                        <check-tag
                            v-for="item in dict.orientation.toList()"
                            class="adv-check-tag"
                            :name="item.id"
                            :key="item.id"
                        >
                            {{ item.text }}
                        </check-tag>
                    </check-tag-group>
                </FormItem> -->
                <!-- 出房 1 publishStatus-->
                <FormItem
                    label="发布状态"
                    prop="publishStatus"
                    v-if="channelType == 1"
                >
                    <check-tag-group
                        v-model="pInfo.publishStatus"
                        color="primary"
                    >
                        <check-tag
                            v-for="item in dict.publishStatus.toList()"
                            class="adv-check-tag"
                            :name="item.id"
                            :key="item.id"
                        >
                            {{ item.text }}
                        </check-tag>
                    </check-tag-group>
                </FormItem>
                <!-- 找房 2 zwzhaoPublishStatus-->
                <FormItem label="发布状态" prop="zwzhaoPublishStatus" v-else>
                    <check-tag-group
                        v-model="pInfo.zwzhaoPublishStatus"
                        color="primary"
                    >
                        <check-tag
                            v-for="item in dict.publishStatus.toList()"
                            class="adv-check-tag"
                            :name="item.id"
                            :key="item.id"
                        >
                            {{ item.text }}
                        </check-tag>
                    </check-tag-group>
                </FormItem>
            </Form>
        </smart-modal>
    </Button>
</template>

<script>
export default {
    name: 'room-adv-search',
    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
        // 发布渠道
        channelType: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            show: false,
            buttons: [
                { type: 'default', text: '重置', name: 'reset' },
                { type: 'primary', text: '确定', name: 'confirm' },
            ],
            btnHandlers: {
                reset: this.onReset,
            },
            dict: {
                houseStatus: this.$dict.NULL,
                orientation: this.$dict.NULL,
                rentTypeNew: this.$dict.NULL,
                publishStatus: this.$dict.NULL,
            },
            pInfo: {
                houseStatus: [],
                rentType: [],
                orientation: [],
                publishStatus: [],
            },
            option: {
                houseStatus: [],
            },
        }
    },
    computed: {
        rules() {},
        isNotEmpty() {
            return Object.values(this.value).some((v) => v.length)
        },
    },
    methods: {
        fetch(next) {
            return Promise.all([
                this.$dict.get([
                    'house_status',
                    'orientation',
                    'rent_type_new',
                    'publish_status',
                ]),
            ])
                .then((args) => {
                    var [group] = args

                    Object.assign(this.dict, group)

                    // 房源状态选项
                    let optionHouseStatus = this.dict.houseStatus.toList()
                    optionHouseStatus = optionHouseStatus.filter((item) => {
                        return item.id != 4 && item.id != 7
                    })
                    this.option.houseStatus = optionHouseStatus

                    // 重新赋值
                    var val = this.value || {}
                    Object.keys(this.pInfo).forEach((k) => {
                        if (typeof val[k] !== 'undefined') {
                            this.pInfo[k] = val[k]
                        }
                    })
                })
                .then(() => next())
        },
        // 获取备选项
        getSelectedOptions() {
            var options = []

            Object.keys(this.pInfo).forEach((k) => {
                var v = this.pInfo[k]

                // prettier-ignore
                switch (k) {
                    case 'houseStatus':
                        v.forEach(p => options.push({
                            id: p,
                            text: this.dict.houseStatus.val(p),
                            key: k,
                            label: '房间状态'
                        }))
                        break
                    case 'rentType':
                        v.forEach(p => options.push({
                            id: p,
                            text: this.dict.rentTypeNew.val(p),
                            key: k,
                            label: '出租类型'
                        }))
                        break
                    case 'orientation':
                        v.forEach(p => options.push({
                            id: p,
                            text: this.dict.orientation.val(p),
                            key: k,
                            label: '朝向'
                        }))
                        break
                    case 'publishStatus':
                        v.forEach(p => options.push({
                            id: p,
                            text: this.dict.publishStatus.val(p),
                            key: k,
                            label: '发布状态'
                        }))
                        break
                    case 'zwzhaoPublishStatus':
                        v.forEach(p => options.push({
                            id: p,
                            text: this.dict.publishStatus.val(p),
                            key: k,
                            label: '发布状态'
                        }))
                        break
                }
            })

            return options
        },
        // 点击筛选
        onClick() {
            this.show = true
        },
        // 确定
        onConfirm() {
            this.$emit('input', this.pInfo)
            this.$emit('confirm', this.pInfo, this.getSelectedOptions())
        },
        // 重置
        onReset(next, options) {
            options.closeModal = false
            Object.keys(this.pInfo).forEach((k) => {
                this.pInfo[k] = typeof this.pInfo[k] === 'object' ? [] : ''
            })
            next()
        },
    },
}
</script>

<style lang="less" scoped>
.adv {
    &-form {
        padding: 0 10px;
    }
    &-text {
        margin-right: 10px;
    }
    &-icon {
        vertical-align: -1px;
    }
    &-check-tag {
        padding: 2px 12px;
        height: auto;
    }
}
</style>
